import { Grid, Stack, Typography } from "@mui/material";
import { Box } from "@mui/system";
import { useContext } from "react";
import { useTranslation } from "react-i18next";
import { ReactComponent as CheckmarkIcon } from "../../../Assets/Icons/Checkmark.svg";
import { ReactComponent as CrossIcon } from "../../../Assets/Icons/Cross.svg";
import { ColorScheme } from "../../../Themes/ColorScheme";
import { ApiContext } from "../../ApiContext";

export const Invitation = ({ invite, refresh }) => {
	const { t } = useTranslation();

	const { ApiCall } = useContext(ApiContext);

	const accept = (invitation_id) => {
		ApiCall("POST", `client/invitation/${invitation_id}`, null).then(
			() => {
				refresh();
				window.location.reload(false);
			}
		);
	};

	const decline = (invitation_id) => {
		ApiCall("DELETE", `client/invitation/${invitation_id}`, null).then(
			() => {
				refresh();
			}
		);
	};

	return (
		<Grid
			item
			textAlign="left"
			sx={{
				color: ColorScheme.primary,
				borderRadius: "4px",
				flexDirection: "row",
				display: "flex",
				justifyContent: "space-between",
				border: "1px solid " + ColorScheme.primary,
				padding: "10px",
				marginBottom: "10px"
			}}
		>
			<Stack>
				<Typography sx={{ fontSize: "14px", fontWeight: "700" }}>
					{invite.location_name !== undefined && invite.location_name}
				</Typography>
				<Typography sx={{ fontSize: "10px", color: ColorScheme.primary }}>
					{t("invites.management")}
				</Typography>
			</Stack>

			<Box
				sx={{
					alignItems: "flex-end",
					display: "flex",
					flexDirection: "column"
				}}
			>
				<Typography sx={{ fontSize: "10px", color: ColorScheme.primary }}>
					{new Date(invite.created_at).toLocaleString()}
				</Typography>
				<Stack
					style={{ justifyContent: "space-between" }}
					direction="row"
				>
					<Box
						onClick={() => accept(invite.id)}
						sx={{
							width: "25px",
							height: "25px",
							borderRadius: "4px",
							backgroundColor: ColorScheme.primary,
							border: "1px solid" + ColorScheme.primary,
							justifyContent: "center",
							alignItems: "center",
							display: "flex",
							marginRight: "5px",
							cursor: "pointer"
						}}
					>
						<CheckmarkIcon
							stroke={ColorScheme.secondary}
						/>
					</Box>
					<Box
						onClick={() => decline(invite.id)}
						style={{
							width: "25px",
							height: "25px",
							borderRadius: "4px",
							backgroundColor: ColorScheme.transparent,
							border: "1px solid" + ColorScheme.primary,
							justifyContent: "center",
							alignItems: "center",
							display: "flex",
							cursor: "pointer"
						}}
					>
						<CrossIcon stroke={ColorScheme.primary} />
					</Box>
				</Stack>
			</Box>
		</Grid>
	);
};
